export default {
    cn: {
        loginRecord: {
            ipText: 'IP',
            downloadName: 'MT4登录记录',
            tableHead: [
                { key: 'ip', value: 'IP' },
                { key: 'login', value: '交易账号' },
                { key: 'last_login_day', value: '最后登入日期' },
                { key: 'name', value: '客户名称' },
                { key: 'currency', value: '入金货币' },
                { key: 'country', value: '国家' },
                { key: 'ib_id', value: '代理账号' },
                { key: 'office_name', value: '所属办事处' },
                { key: 'oid', value: '办事处号码' },
                { key: 'acc_name', value: '所属地区' },
                { key: 'rid', value: '地区编号' },
            ],
            searchKeys: { ip: 'IP', login: '交易账号' },
            validWarning: '请输入正确的值',
        }
    },
    hk: {
        loginRecord: {
            ipText: 'IP',
            downloadName: 'MT4登入記錄',
            tableHead: [
                { key: 'ip', value: 'IP' },
                { key: 'login', value: '交易賬號' },
                { key: 'last_login_day', value: '最後登入日期' },
                { key: 'name', value: '客戶名稱' },
                { key: 'currency', value: '入金貨幣' },
                { key: 'country', value: '國家' },
                { key: 'ib_id', value: '代理賬號' },
                { key: 'office_name', value: '所屬辦事處' },
                { key: 'oid', value: '辦事處號碼' },
                { key: 'acc_name', value: '所屬地區' },
                { key: 'rid', value: '地區編號' },
            ],
            searchKeys: { ip: 'IP', login: '交易賬號' },
            validWarning: '請輸入正確的值',
        }
    },
    en: {
        loginRecord: {
            ipText: 'IP',
            downloadName: 'MT4 Login Records',
            tableHead: [
                { key: 'ip', value: 'IP' },
                { key: 'login', value: 'Login' },
                { key: 'last_login_day', value: 'Last Login Day' },
                { key: 'name', value: 'Name' },
                { key: 'currency', value: 'Currency' },
                { key: 'country', value: 'Country' },
                { key: 'ib_id', value: 'IB Account' },
                { key: 'office_name', value: 'Office Name' },
                { key: 'oid', value: 'Office ID' },
                { key: 'acc_name', value: 'Region Name' },
                { key: 'rid', value: 'Region ID' },
            ],
            searchKeys: { ip: 'IP', login: 'Login' },
            validWarning: 'Please enter the correct value',
        }
    }
}


// WEBPACK FOOTER //
// ./src/language/record/loginRecord.js